export default {
	default: [''],
	defaultBg1: ['progress-bar--bg-1'],
	defaultBg2: ['progress-bar--bg-2']
};
